import { state, trigger, style, transition, animate } from '@angular/animations';
import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';

import { MenuItem } from '../core/context.service';
import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'tv-menu-item',
  templateUrl: './menu.item.component.html',
  styleUrls: [
    './menu.item.component.scss'
  ],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2 ,1)')
      ),
    ])
  ]
})
export class MenuItemComponent implements OnInit {
  expanded: boolean;

  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() menuItem: MenuItem;
  @Input() depth: number;
  @Input() sideNav: MatSidenav;

  constructor(public router: Router,
    private route: ActivatedRoute,
    private constants: Constants,
    private configurationService: ConfigurationService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    if (this.menuItem.relativePath && this.route.snapshot.url) {
      this.expanded = this.route.snapshot.url.indexOf(new UrlSegment(`/${this.menuItem.relativePath}`, null)) === 0;
      this.ariaExpanded = this.expanded;
    }
  }

  onItemSelected() {
    if (this.menuItem.relativePath && this.menuItem.relativePath.length > 0) {
      /*if (this.menuItem.screenId >= this.constants.Screen.reportsdashboard) {
        console.log('Menu is report', this.menuItem);
        this.configurationService.navigate(this.menuItem.relativePath);
      } else {
        this.router.navigate([this.menuItem.relativePath]);
        this.sideNav.toggle();
      }*/
      this.router.navigate([this.menuItem.relativePath], { queryParams: this.menuItem.queryString });
      this.sideNav.toggle();
    }
    if (this.menuItem.children && this.menuItem.children.length) {
      this.expanded = !this.expanded;
    }
  }
  getIconForDisplayName(displayName: string): string {
    const iconMap: { [key: string]: string } = {
      'Product Setup': 'assignment',
      'KYC': 'verified_user',
      'Core Setup': 'build',
      'Module Setup': 'apps',
      'Pigmy': 'attach_money',
      'Vista': 'account_balance',
      'Cash': 'monetization_on',
      'Vouchers': 'card_giftcard',
      'CASA': 'account_box',
      'Wallet': 'account_balance_wallet',
     // 'RD': 'trending_up',
      //'Share': 'supervisor_account',
      'Loans': 'local_atm',
      'Overdraft': 'credit_card',
      'Security Management': 'security',
      'Reports': 'assessment',
      'Reports Dashboard': 'dashboard',
      'Download': 'file_download',
      'Holiday Parameter': 'date_range',
      'Report Configuration ': 'report',
      'Query Builder': 'data_usage',
      'Approve': 'check_circle',
      'EOD Process': 'event',
      'Daily Loan': 'event_note',
      'Upload': 'cloud_upload',
      'Investment': 'trending_up',
      'Micro Lending': 'credit_card',
      'Standing Instruction': 'credit_card',
      'HO Reports': 'assessment',
      'Branch Reports': 'assessment',
      'RBZ Reports': 'assessment',
      'Operation and Recoveries Reports': 'assessment',
      'Finance Reports': 'assessment',
      'BD Reports': 'assessment',
      'Audit Log Reports': 'assessment',
      'XDS Reports': 'assessment',
      'Weekly Loan': 'local_atm',
      'Weekly Loan Product': 'assignment',
      'Weekly Loan Reports': 'assessment',
      'Shares': 'groups',
      'Transfer': 'swap_horiz',
      'Batch Process': 'playlist_add_check',
      'EOD': 'event_available',
      'Channel Parameter': 'settings_input_antenna',
      'PAR Report': 'assessment',
      'A/c / GL Reconciliation': 'account_balance_wallet',
      'TD ':  'trending_up',
    };

    return iconMap[displayName] || 'default_icon';
  }

}


